import { render, staticRenderFns } from "./documentHistory.vue?vue&type=template&id=5b193d5b&scoped=true&"
import script from "./documentHistory.vue?vue&type=script&lang=js&"
export * from "./documentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b193d5b",
  null
  
)

export default component.exports